module.exports = __webpack_public_path__ + "img/沙洲坝中华苏维埃共和国中央人民委员会旧址.0c864f62.png";